/*
 * @Author: xinxinfeng 2273234784@qq.com
 * @Date: 2024-07-01 14:11:23
 * @LastEditors: xinxinfeng 2273234784@qq.com
 * @LastEditTime: 2024-12-05 15:38:30
 * @FilePath: \crane-safety-manager\src\pages\VehicleModal.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useEffect } from 'react';
import { Form } from 'antd';
import { ModalForm, ProForm, ProFormGroup, ProFormList, ProFormSelect, ProFormText } from '@ant-design/pro-components';
import { useSelector } from 'react-redux';
import _ from 'lodash';

import '../assets/scss/_custom.scss';

const VehicleModal = ({ open, vehicle, onOpenChange, onOk, isEdit }) => {
    const [form] = Form.useForm();

    const sitesList = useSelector(state => state.Sites.dataList);
    const workerRoles = ['司机', '安全员', '司索工', '信号员'];
    const filedRules = {
        siteId: [{ required: true, message: '请选择所属工地' }],
        licensePlate: [{ required: true, message: '请输入车牌' }],
        brand: [{ required: true, message: '请输入品牌' }],
        type: [{ required: true, message: '请输入类型' }],
        maxLoad: [{ required: true, message: '请输入最大起重重量' }],
        entryDate: [
            { required: true, message: '请输入进场时间' },
            { pattern: /^\d{4}-\d{2}-\d{2}$/, message: '日期格式不正确' }
        ],
        sn: [{ required: true, message: '请输入设备序列号' }],
        deviceSerial: [{ required: true, message: '请输入摄像头序列号' }],
        validateCode: [{ required: true, message: '请输入摄像头验证码' }],
        name: [{ required: true, message: '姓名' }],
        phone: [{ required: true, message: '电话' },{pattern: /^1\d{10}$/,message: '请输入正确的手机号'},]
    };

    useEffect(() => {
        if (!_.isObject(vehicle) || _.isEmpty(vehicle)) {
            form.setFieldsValue(null);
            form.isFieldsTouched();
            console.log('resetFields');
            return;
        }
        form.setFieldsValue({ ...vehicle });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [vehicle]);

    return (
        <ModalForm forceRender getContainer={false} title={isEdit ? '编辑' : '新增'} open={open} form={form} autoFocusFirstInput initialValues={vehicle} modalProps={{ destroyOnClose: true }} submitTimeout={2000} onFinish={onOk} onOpenChange={onOpenChange}>
            <ProForm.Group>
                <ProFormSelect width="md" name="siteId" label="所属工地" rules={filedRules['siteId']} placeholder="请选择所属工地" options={(sitesList || []).map(x => ({ label: x.siteName, value: x.id }))} />
                <ProFormText width="md" name="licensePlate" label="车牌" rules={filedRules['licensePlate']} placeholder="车牌" />
            </ProForm.Group>
            <ProForm.Group>
                <ProFormText width="md" name="brand" label="品牌" rules={filedRules['brand']} placeholder="品牌" />
                <ProFormText width="md" name="type" label="类型" rules={filedRules['type']} placeholder="类型" />
                <ProFormText width="md" name="maxLoad" label="最大起重重量" rules={filedRules['maxLoad']} placeholder="起重量" />
                <ProFormText width="md" name="entryDate" label="进场时间" rules={filedRules['entryDate']} placeholder="YYYY-MM-DD" />
            </ProForm.Group>
            <ProForm.Group>
                <ProFormText width="md" name="sn" label="设备序列号" rules={filedRules['sn']} placeholder="设备序列号" />
                <ProFormText width="md" name="deviceSerial" label="摄像头序列号" rules={filedRules['deviceSerial']} placeholder="摄像头序列号" />
                <ProFormText width="md" name="validateCode" label="摄像头验证码" rules={filedRules['validateCode']} placeholder="摄像头验证码" />
            </ProForm.Group>
            <ProFormList className="worker-list" name="workers" initialValue={workerRoles.map(x => ({ role: x }))} creatorButtonProps={{ position: 'bottom', creatorButtonText: '添加人员' }}>
                <ProFormGroup style={{ gap: '0 24px' }} >
                    <ProFormSelect key="role" options={workerRoles} width="sm" name="role" label="角色" />
                    <ProFormText key="name" width="sm" name="name" label="姓名" rules={filedRules['name']} placeholder="姓名" />
                    <ProFormText key='phone' width='sm' name='phone' label='电话' rules={filedRules['phone']} placeholder={'电话'}/>
                </ProFormGroup>
            </ProFormList>
        </ModalForm>
    );
};

export default VehicleModal;
